/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountemaillabel2Inputs */

const en_accountemaillabel2 = /** @type {(inputs: Accountemaillabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in as`)
};

const pt_accountemaillabel2 = /** @type {(inputs: Accountemaillabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sessão iniciada como`)
};

/**
* | output |
* | --- |
* | "Signed in as" |
*
* @param {Accountemaillabel2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const accountemaillabel2 = /** @type {((inputs?: Accountemaillabel2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountemaillabel2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_accountemaillabel2(inputs)
	return pt_accountemaillabel2(inputs)
});
export { accountemaillabel2 as "accountEmailLabel" }